import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
  getClassApplicableService,
  getClassSearchList,
  putLookupDetails,
} from "../../Actions/lookupAPI";
import Autocomplete from "react-autocomplete";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import {
  getApplicableServiceTypeListWithInterval,
  getEquipmentNameListAndId,
} from "../../Actions/helpersAPI";
import { validateFields } from "../../Utils/utilities";
import MinusIcon from "../../UIComponents/MinusIcon";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import AddIcon from "../../UIComponents/AddIcon";
import axios from "axios";
import API from "../../helpers/api";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class ClassDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classinfo: {
        Class: "",
        classId: 0,
        isDeleted: false,
        modifiedBy: currentuser.name,
        equipmentName: "",
        equipmentId: 0,
        capacity: "",
        category: "",
        equipmentType: "",
      },
      modalIsOpen: false,
      ApplicableServices: [],
      ApplicableServicesList: [],
      ServiceTypeList: [],
      selectedServiceYears: [],
      isClassNew: true,
      openEquipment: false,
    };
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      // this.props.history.goBack();
    };
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getEquipmentNameListAndId());
    dispatch({ type: "SubBannerTitle", data: "Class" });
    dispatch(getClassApplicableService(match.params.id));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      LookupDetails,
      match,
      dispatch,
      GetClassApplicableService,
      ClassApplicableServices,
      ClassapplicableServiceType,
    } = nextProps;
    const { params } = match;
    const { type } = params;
    if (LookupDetails && LookupDetails !== "") {
      prevState.classinfo.Class = LookupDetails.lookUpName;
      prevState.classinfo.classId = LookupDetails.lookUpId;
      dispatch({ type: "classDetails", data: "" });
    }
    if (GetClassApplicableService && GetClassApplicableService !== "") {
      prevState.ApplicableServicesList =
        GetClassApplicableService &&
        GetClassApplicableService.map((u) => {
          let data = {
            classApplicableServiceId: u.classApplicableServiceId,
            classId: u.classId,
            serviceType: u.serviceType,
            serviceTypeId: u.serviceTypeId,
            equipmentId: u.equipmentId,
            isShore: u.isShore,
            equipmentName: u.equipmentName,
            capacity: u.capacity,
            category: u.category,
            equipmentType: u.equipmentType,
            radioButton: u.isShore ? "Shore" : "Ship",
            isDeleted: false,
          };
          return data;
        });
      dispatch({ type: "getClassApplicableServiceSuccess", data: "" });
    }
    if (ClassApplicableServices) {
      prevState.ApplicableServicesList = ClassApplicableServices;
    }
    if (
      ClassapplicableServiceType &&
      ClassapplicableServiceType !== "" &&
      prevState.ApplicableServices &&
      prevState.ApplicableServices.length === 0
    ) {
      dispatch({ type: "getServiceTypeIntervalListFlagSuccess", data: "" });
      prevState.ApplicableServices =
        ClassapplicableServiceType.length &&
        ClassapplicableServiceType.map((d, i) => {
          let obj = {
            classEquipmentServiceId: 0,

            serviceType: d.serviceType,
            serviceTypeId: d.serviceTypeId,
            equipmentId: prevState.classinfo.equipmentId,
            equipmentName: prevState.classinfo.equipmentName,
            capacity: prevState.classinfo.capacity,
            category: prevState.classinfo.category,
            equipmentType: prevState.classinfo.equipmentType,
            isShore: false,
            radioButton: "",
            isDeleted: false,
            classId: parseInt(match.params.id),
          };
          return obj;
        });
    }
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookUpClass");
  };

  render() {
    const { t } = this.props;
    const { ApplicableServices } = this.state;
    return <div className="pb-3">{this.renderCardData()}</div>;
  }

  renderCardData() {
    const {
      showSidePane,
      arraylist,
      EquipmentNameListAndId,
      Loading,
      t,
      ClassManagementDetails,
    } = this.props;
    const { ApplicableServicesList } = this.state;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card MM-card-header mt-2"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                   {t("ClassScreen.ClassDetails")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-sm-6 mb-1">
                  <span>
                    <strong>{t("ClassScreen.Title")}: </strong>
                    <span className="lato">
                      {ClassManagementDetails.lookUpName
                        ? ClassManagementDetails.lookUpName
                        : ""}
                    </span>
                  </span>
                </div>
              </div>

              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ClassScreen.ApplicableServices")}
                    </h5>
                  </div>
                </div>

                {ApplicableServicesList && ApplicableServicesList.length ? (
                  ApplicableServicesList.map((item, index) => {
                    if (!item.isDeleted) {
                      return (
                        <div
                          className="card m-3"
                          style={{
                            backgroundColor: "#f0f0f0",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div className="p-3">
                            <div className="resource-list-auth-date">
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-12 m-auto">
                                  <div className="row">
                                    <div className="col-sm-7">
                                      <span>
                                        <strong>
                                          {t(
                                            "ShipEquipmentStatusScreen.EquipmentName"
                                          )}{" "}
                                          :{" "}
                                        </strong>
                                        {item.equipmentName}&nbsp; (
                                        {item.category &&
                                        (item.capacity || item.equipmentType)
                                          ? item.category + ","
                                          : item.category
                                          ? item.category
                                          : ""}
                                        &nbsp;{" "}
                                        {item.capacity &&
                                        (item.category || item.equipmentType)
                                          ? item.capacity + ","
                                          : item.capacity
                                          ? item.capacity
                                          : ""}
                                        &nbsp;{" "}
                                        {item.equipmentType
                                          ? item.equipmentType
                                          : ""}
                                        )
                                      </span>
                                    </div>
                                    <div className="col-sm-3">
                                      <span>
                                        <strong>
                                          {t("content.Servicetype")} :{" "}
                                        </strong>
                                        {item?.serviceType}
                                      </span>
                                    </div>
                                    <div className="col-sm-2">
                                      <span>
                                        <strong>
                                          {t("ComplianceandBudgetScreen.Type")}{" "}
                                          :{" "}
                                        </strong>
                                        {item?.isShore ? "Shore" : "Ship"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <div
                    className="card m-3"
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <div class="container">
                      <h6 className="resource-list-title no-item-card">
                        {t("CommonText.NoTasks")}
                      </h6>
                    </div>
                  </div>
                )}

                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    LookupDetails: state.MasterScreenReducer.ClassListDetails,
    EquipmentNameListAndId:
      state.MasterScreenReducer.EquipmentNameListAndId || [],
    GetClassApplicableService:
      state.lookupReducer.GetClassApplicableService || null,
    ClassapplicableServiceType:
      state.MasterScreenReducer.ClassapplicableServiceType || null,
    ClassManagementDetails: state.MasterScreenReducer.ClassManagementDetails,
    ClassApplicableServices:
      state.MasterScreenReducer.ClassApplicableServices || null,
    Loading: state.PageLoaderReducer.loading,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ClassDetails)
);
